import { render } from "./TgServices.vue?vue&type=template&id=5f041f83"
import script from "./TgServices.vue?vue&type=script&lang=js"
export * from "./TgServices.vue?vue&type=script&lang=js"
script.render = render

export default script